// client/extensions/DocumentExtension.ts
import "@adornis/chemistry/elements/components/x-flex.js";
import { html } from "lit";
var DocumentExtension = {
  render(content) {
    return html` <x-flex> ${content} </x-flex> `;
  }
};
export {
  DocumentExtension
};
